import { render, staticRenderFns } from "./block-video.vue?vue&type=template&id=5ae2bb6f"
import script from "./block-video.vue?vue&type=script&lang=js"
export * from "./block-video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports